import { EPageName } from "@/util/enum"
import TransformDetailCard, { TransformDetailCardProps } from "./TransformDetailCard"
import CategorySwiper from "@/components/ui/swiper/CategorySwiper"

interface CrouselTransforSectionProps{
  crouselData:TransformDetailCardProps[]
}

const CrouselTransforSection = ({crouselData}:CrouselTransforSectionProps) => {

  return (
    <div className="w-full mt-2.5">
      <CategorySwiper pageName={EPageName?.CATEGORY} crouselData={crouselData} renderItem={(item) => (
        <TransformDetailCard
          url={item?.url}
          alt_name={item?.alt_name}
          heading={item?.heading}
          description={item?.description}
          slug={item?.slug}
        />
      )} />
    </div>
  )
}

export default CrouselTransforSection